import models from './models.js';
import pages from './pages/index.js';
import actions from './actions.js';
import messages from './messages.js';
import theme from './theme.js';

export default {
	common: { loading: 'Loading…', step: 'Step' },
	models,
	pages,
	actions,
	messages,
	theme,
	scrollActionController: {
		non_text_content: 'Non-text content detected'
	},
	charts: {
		riskScatter: {
			likelihood: 'Likelihood',
			impact: 'Impact'
		}
	}
};
